import React from 'react';
import { StepProps, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Activation({
  state,
  nextStep
}: StepProps) {
  const role = state.selectedSpecialty || 'Nephrologist';
  const color = SPECIALTY_COLORS[role];
  const recommendations = {
    Nephrologist: ['Emphasize safety data and monitoring confidence', 'Provide clear treatment sequencing guidance', 'Address late-referral frustration with earlier intervention evidence', 'Lead with robust clinical trial data'],
    Cardiologist: ['Highlight early outcome benefits and CV protection', 'Simplify treatment integration into existing protocols', 'Reinforce dual organ (heart + kidney) protection narrative', 'Leverage their proactive, aggressive mindset'],
    Endocrinologist: ['Focus on metabolic pathway alignment', 'Provide clear triggers for when to escalate beyond SGLT2/GLP1', 'Support their data-driven approach with biomarker evidence', 'Address hesitancy about non-glycaemic management'],
    PCP: ['Prioritize simplicity and clear patient identification criteria', 'Provide step-by-step escalation pathways', 'Use guidelines and peer advocacy as social proof', 'Lower the barrier to initiating foundational therapies']
  };
  const currentRecs = recommendations[role];
  return <div className="flex-grow flex flex-col py-12 px-6 overflow-y-auto" data-id="element-178">
      <div className="max-w-4xl w-full mx-auto" data-id="element-179">
        <div className="text-center mb-12" data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-4" data-id="element-181">
            How to engage {role}s more effectively
          </h2>
          <p className="text-xl text-gray-500" data-id="element-182">
            Based on their unique drivers and barriers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-183">
          {currentRecs.map((rec, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.15
        }} className="bg-white rounded-2xl p-8 border-2 shadow-sm flex items-start" style={{
          borderColor: `${color}30`
        }} data-id="element-184">
              <CheckCircle2 size={28} className="mr-4 flex-shrink-0 mt-1" style={{
            color
          }} data-id="element-185" />
              <p className="text-lg font-medium text-dark leading-relaxed" data-id="element-186">
                {rec}
              </p>
            </motion.div>)}
        </div>

        <div className="flex justify-center pb-12" data-id="element-187">
          <motion.button initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} onClick={nextStep} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors" data-id="element-188">
            See Summary
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-189" />
          </motion.button>
        </div>
      </div>
    </div>;
}